  <div id="main" [ngClass]="{'shifted': isOpen, 'backdrop': isOpen}" *ngIf="admin.isAdmin()" (click)="closeSidebar($event)">
    
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">

        <a class="menu" (click)="toggleNav($event)" >
          <i class="fi fi-rr-bars-staggered"></i>
        </a>
        
        <ul class="nav d-none d-md-flex">
          <li class="nav-item mt-1">
            <span class="nav-link text-color">{{ admin.user.name }} {{ admin.user.lastname }}</span>
          </li>

          <li class="nav-item mt-1">
            <a class="nav-link d-flex" *ngIf="currentLang !== 'geo'" (click)="switchLanguage('geo')">
              <img class="flag mx-1" src="/assets/images/ge.png" alt="ქართული" /> ქართული
            </a>
            <a class="nav-link d-flex" *ngIf="currentLang !== 'eng'" (click)="switchLanguage('eng')">
              <img class="flag mx-1" src="/assets/images/us.png" alt="English" /> English
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link text-color" href="https://sca.ge/" target="_blank"><i class="fi fi-rr-site-alt"></i></a>
          </li>

          <li class="nav-item">
            <a class="nav-link text-color" (click)="logout()"><i class="fi fi-rr-sign-out-alt"></i></a>
          </li>
        </ul>

        <!-- Mobile dropdown (below 768px) -->
        <div ngbDropdown class="d-md-none " >
          <button ngbDropdownToggle class="btn btn-sm">
            {{ admin.user.name }} {{ admin.user.lastname }} <i class="fi fi-rr-user"></i>
          </button>
          <ul ngbDropdownMenu class="dropdown-menu ">
            <li ngbDropdownItem>
              <a class="dropdown-item" *ngIf="currentLang !== 'geo'" (click)="switchLanguage('geo')">
                <img class="flag" src="/assets/images/ge.png" alt="ქართული" /> ქართული
              </a>
              <a class="dropdown-item" *ngIf="currentLang !== 'eng'" (click)="switchLanguage('eng')">
                <img class="flag" src="/assets/images/us.png" alt="English" /> English
              </a>
            </li>
            <li ngbDropdownItem>
              <a class="dropdown-item" href="https://sca.ge/" target="_blank"><i class="fi fi-rr-site-alt"></i> sca.ge</a>
            </li>
            <li ngbDropdownItem>
              <a class="dropdown-item" (click)="logout()"><i class="fi fi-rr-sign-out-alt"></i> გასვლა</a>
            </li>
          </ul>
        </div>

     
        
      

      </div>
    </nav> 

 
    <!-- <div #scrollContainer style="height: 100vh; overflow-y: auto;">
      <router-outlet></router-outlet>
    </div> -->
      <router-outlet></router-outlet>


  </div>

  <div class="container-fluid" *ngIf="!admin.isAdmin()">
    <router-outlet></router-outlet>
  </div>

  <div class="sidebar" [ngClass]="{'open': isOpen}" *ngIf="admin.isAdmin()">
    <a routerLink="/">
      <img src="assets/logo/logo.svg" class="logo-sidebar ps-4"/>
    </a>


    <div class="list-group list-group-flush  ps-4 mt-2">

      
     <a 
        class="list-group-item d-flex" 
        [routerLink]="['/menu']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
       *ngIf="admin.hasPermission('menus_view')"
        
        >
          <i class="fi fi-rr-drop-down"></i>
          <span class="mx-1">მენიუ</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/posts']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('posts')">
           <i class="fi fi-rr-newspaper"></i>
          <span class="mx-1">სტატიები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/calendar']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('calendar')">
           <i class="fi fi-rr-calendar"></i>
          <span class="mx-1">კალენდარი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/team']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('team')">
          <!-- <i class="fi fi-rs-employees"></i> -->
          <i class="fi fi-rr-people"></i>
          <span class="mx-1">ჩვენი გუნდი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/banner']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('banner')">
          <i class="fi fi-rr-list"></i>
          <span class="mx-1">მარჯვენა ბლოკი</span>
      </a>


      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/forms']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('forms')">
          <i class="fi fi-rr-form"></i>
          <span class="mx-1">ფორმები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/faq']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('faq')">
          <i class="fi fi-rr-interrogation"></i>
          <span class="mx-1">კითხვა პასუხი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/gallery']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('gallery')">
          <i class="fi fi-rr-gallery"></i>
          <span class="mx-1">გალერეა</span>
      </a>

      

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/files']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-folder-open"></i>
          <span class="mx-1">ფაილები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/live']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('live')">
          <i class="fi fi-rr-live-alt"></i>
          <span class="mx-1">ლაივი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/comments']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('comments')">
          <i class="fi fi-rr-comment-dots"></i>
          <span class="mx-1">კომენტარები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/admins']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('admins')">
           <i class="fi fi-rr-admin-alt"></i>
          <span class="mx-1">ადმინები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/setting']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('settings')">
           <i class="fi fi-rr-settings"></i>
          <span class="mx-1">პარამეტრები</span>
      </a>
      
      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/logs']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('logs')">
          <i class="fi fi-rs-file-circle-info"></i>
          <span class="mx-1">ლოგები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/info']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('info')">
          <i class="fi fi-rr-info"></i>
          <span class="mx-1">ინფო</span>
      </a>
      
      

    </div>
  </div>






